"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DISMISSED_COUNT_KEY = exports.LAST_RENDERED_KEY = exports.DISMISSED_KEY = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dialog = _interopRequireDefault(require("../dialog"));

var _timedReveal = _interopRequireDefault(require("../timed-reveal"));

var _madLibUtil = require("./mad-lib-util");

require("./mad-lib-popup.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Local storage keys
var DISMISSED_KEY = '_gf_mad_lib_dismissed_popup';
exports.DISMISSED_KEY = DISMISSED_KEY;
var LAST_RENDERED_KEY = '_gf_mad_lib_last_rendered_popup';
exports.LAST_RENDERED_KEY = LAST_RENDERED_KEY;
var DISMISSED_COUNT_KEY = '_gf_mad_lib_dismissed_popup_count';
/** MadLibPopUp is a controlled popup inside of MadLib. */

exports.DISMISSED_COUNT_KEY = DISMISSED_COUNT_KEY;

var MadLibPopUp = /*#__PURE__*/function (_React$Component) {
  _inherits(MadLibPopUp, _React$Component);

  var _super = _createSuper(MadLibPopUp);

  /**
   * Create a popup
   * @param {Object} props - react props
   * @param {Node} props.children - React children
   * @param {Function} props.onClose - cb for onRequestClose
   * @param {String} props.id - Unique ID for popup
   * @param {Number} props.delay - Milliseconds of delay for popup
   * @param {Number} props.maxShowCount - Max number of times to show the popup
   * @param {Nubmer} props.showAgainAfterDays - Number of days to wait to show popup again
   * @returns {MadLibPopUp}
   */
  function MadLibPopUp(props) {
    var _this;

    _classCallCheck(this, MadLibPopUp);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeDialog", function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          maxShowCount = _this$props.maxShowCount;

      if (_lodash["default"].isFunction(onClose)) {
        onClose();
      }

      _this.setState({
        dismissed: true
      });

      MadLibPopUp.setDismissed(true);
      MadLibPopUp.incrementDismissedCount();

      if (MadLibPopUp.getDismissedCount() === maxShowCount) {
        (0, _madLibUtil.dismissedMaxTimesAnalytics)();
      }
    });

    _this.state = {
      dismissed: true
    };
    return _this;
  }

  _createClass(MadLibPopUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.shouldShowPopup()) {
        MadLibPopUp.setDismissed('false');
        this.setState({
          dismissed: false
        });
      }

      MadLibPopUp.setLastRendered(Date.now());
    }
  }, {
    key: "shouldShowPopup",
    value:
    /**
     * If the user hasn't visited the site for a few days we want to show them this popup again.
     * There is a limit on the total number of times the popup will be displayed
     */
    function shouldShowPopup() {
      var _this$props2 = this.props,
          showAgainAfterDays = _this$props2.showAgainAfterDays,
          maxShowCount = _this$props2.maxShowCount;
      var msSinceLastRender = MadLibPopUp.getMsSinceLastRender();
      var dismissedCount = MadLibPopUp.getDismissedCount();
      var dismissed = MadLibPopUp.getDismissed();
      var msInDay = 1000 * 60 * 60 * 24;
      var daysSinceLastRender = msSinceLastRender / msInDay;

      if (dismissed && daysSinceLastRender > showAgainAfterDays && dismissedCount < maxShowCount) {
        return true;
      }

      return !dismissed;
    }
  }, {
    key: "render",
    value: function render() {
      var dismissed = this.state.dismissed;

      if (dismissed) {
        return null;
      }

      var _this$props3 = this.props,
          children = _this$props3.children,
          delay = _this$props3.delay,
          id = _this$props3.id,
          hiddenProp = _this$props3.hidden;
      var overlayClasses = (0, _classnames["default"])("MadLibPopUp-dialogOverlay madlib-id-".concat(id), {
        hidden: hiddenProp
      });

      var popup = /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('MadLibPopUp')
      }, /*#__PURE__*/_react["default"].createElement(_dialog["default"], {
        overlayClassName: overlayClasses,
        className: "MadLibPopUp-Dialog madlib-id-".concat(id),
        onRequestClose: this.closeDialog,
        withScrollBox: false,
        showTopRightCloseButton: true,
        withPadding: true,
        isOpen: true
      }, children));

      if (delay) {
        return /*#__PURE__*/_react["default"].createElement(_timedReveal["default"], {
          delay: delay
        }, popup);
      }

      return popup;
    }
  }], [{
    key: "hasLocalStorage",
    value: function hasLocalStorage() {
      return !!(typeof window !== 'undefined' && window.localStorage);
    }
  }, {
    key: "getItem",
    value: function getItem(key, defaultValue) {
      if (!MadLibPopUp.hasLocalStorage()) {
        return defaultValue || null;
      }

      return window.localStorage.getItem(key) || defaultValue || null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!MadLibPopUp.hasLocalStorage()) {
        return;
      }

      window.localStorage.setItem(key, value);
    }
  }, {
    key: "getNumberFromLocalStorage",
    value: function getNumberFromLocalStorage(key, defaultValue) {
      var value = MadLibPopUp.getItem(key);

      if (value === null) {
        return defaultValue;
      }

      var valueAsNumber = parseFloat(value, 10); // eslint-disable-next-line no-restricted-globals

      if (isNaN(valueAsNumber)) {
        return defaultValue;
      }

      return valueAsNumber;
    }
  }, {
    key: "getMsSinceLastRender",
    value: function getMsSinceLastRender() {
      var lastRenderedNumber = MadLibPopUp.getNumberFromLocalStorage(LAST_RENDERED_KEY, 0);
      return Date.now() - lastRenderedNumber;
    }
  }, {
    key: "setDismissedCount",
    value: function setDismissedCount(dismissedCount) {
      MadLibPopUp.setItem(DISMISSED_COUNT_KEY, dismissedCount);
    }
  }, {
    key: "getDismissedCount",
    value: function getDismissedCount() {
      return MadLibPopUp.getNumberFromLocalStorage(DISMISSED_COUNT_KEY, 0);
    }
  }, {
    key: "setDismissed",
    value: function setDismissed(dismissed) {
      MadLibPopUp.setItem(DISMISSED_KEY, dismissed);
    }
  }, {
    key: "getDismissed",
    value: function getDismissed() {
      return MadLibPopUp.getItem(DISMISSED_KEY, 'false') === 'true';
    }
  }, {
    key: "incrementDismissedCount",
    value: function incrementDismissedCount() {
      MadLibPopUp.setDismissedCount(MadLibPopUp.getDismissedCount() + 1);
    }
  }]);

  return MadLibPopUp;
}(_react["default"].Component);

_defineProperty(MadLibPopUp, "propTypes", {
  showAgainAfterDays: _propTypes["default"].number,
  maxShowCount: _propTypes["default"].number,
  children: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string,
  delay: _propTypes["default"].number,
  onClose: _propTypes["default"].func,
  hidden: _propTypes["default"].bool
});

_defineProperty(MadLibPopUp, "defaultProps", {
  showAgainAfterDays: 3,
  maxShowCount: 3,
  id: '',
  delay: 0,
  onClose: function onClose() {},
  hidden: false
});

_defineProperty(MadLibPopUp, "setLastRendered", function (lastRendered) {
  MadLibPopUp.setItem(LAST_RENDERED_KEY, lastRendered);
});

var _default = MadLibPopUp;
exports["default"] = _default;